type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  strokeColor?: string;
};

/** Smiley face — used for the "add emoji / reaction" affordance. */
const EmojiIcon = (props: Props) => {
  const {
    width = '20',
    height = '20',
    viewBox = '0 0 20 20',
    strokeColor = 'currentColor',
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
    >
      <circle cx="10" cy="10" r="7.25" stroke={strokeColor} strokeWidth="1.5" />
      <path
        d="M7.25 8.25h.008"
        stroke={strokeColor}
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path
        d="M12.75 8.25h.008"
        stroke={strokeColor}
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path
        d="M7.25 12c.6.9 1.6 1.5 2.75 1.5S12.15 12.9 12.75 12"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EmojiIcon;
